import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faculty-profile',
  templateUrl: './faculty-profile.component.html',
  styleUrls: ['./faculty-profile.component.css']
})
export class FacultyProfileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
